var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1953 18.8359C17.4557 18.8359 17.7083 18.8151 17.9531 18.7734C18.2031 18.7318 18.4401 18.6693 18.6641 18.5859L18.9453 20.4141C18.638 20.487 18.3151 20.5443 17.9766 20.5859C17.638 20.6276 17.2943 20.6484 16.9453 20.6484C16.2891 20.6484 15.6849 20.5573 15.1328 20.375C14.5807 20.1927 14.1016 19.9193 13.6953 19.5547C13.2943 19.1849 12.9818 18.7292 12.7578 18.1875C12.5339 17.6406 12.4219 17.0026 12.4219 16.2734V13.5781C12.4219 12.8177 12.5339 12.151 12.7578 11.5781C12.987 11.0052 13.3099 10.526 13.7266 10.1406C14.1432 9.75521 14.638 9.46615 15.2109 9.27344C15.7839 9.07552 16.4193 8.97656 17.1172 8.97656C17.4245 8.97656 17.7292 9 18.0312 9.04688C18.3385 9.08854 18.6432 9.14583 18.9453 9.21875L18.6641 11.0547C18.4609 10.9766 18.2318 10.9141 17.9766 10.8672C17.7266 10.8203 17.4792 10.7969 17.2344 10.7969C16.849 10.7969 16.5026 10.8516 16.1953 10.9609C15.888 11.0651 15.6276 11.2292 15.4141 11.4531C15.2057 11.6719 15.0469 11.9557 14.9375 12.3047C14.8281 12.6536 14.7734 13.0729 14.7734 13.5625V16.2734C14.7734 16.7526 14.8307 17.1589 14.9453 17.4922C15.0599 17.8203 15.224 18.0833 15.4375 18.2812C15.651 18.474 15.9062 18.6146 16.2031 18.7031C16.5 18.7917 16.8307 18.8359 17.1953 18.8359ZM17.3828 13.1406V14.2969H11.1016V13.1406H17.3828ZM17.3828 15.2891V16.4453H11.1016V15.2891H17.3828Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.05e184325d938db10527e16b14fdfc97.svg";
export { ForwardRef as ReactComponent };